/**
 * @requires ./frc.js
 */

frc.pages.careersSearch = {
 	"config": {
 		"maxDistanceMiles": 100,
 		"maxResultsPerPage": 100
 	},
 	"data": {
 		"listings": null,
 		"biasing": {
 			"type": null,
 			"value": {
 				"raw": null,
 				"coords": null,
 				"geocoded": null
 			},
 			"method": null
 		},
 		"geocodePerformed": false
 	},
 	"init": function(){

 		var self = frc.page = frc.pages.careersSearch;

 		$(self).on("parametersset", function(){
 			self.data.careersModule.search();
 		}).on("geocodefailed", function(){
			self.data.careersModule.renderResults({
				"messageType": "geocodefailed",
				"geocodeQuery": self.data.biasing.value.raw
			});
 		});

		// Determine parameters
		var query = frc.utilities.getUrlParameter("query");
		var brandIDs = frc.utilities.getUrlParameter("brand_ids");
		var locationIDs = frc.utilities.getUrlParameter("location_ids");
		var categories = frc.utilities.getUrlParameter("categories");
		var resultsPerPage = window.parseFloat(frc.utilities.getUrlParameter("results"));
		var maxDistanceMiles = window.parseFloat(frc.utilities.getUrlParameter("distance"));
		var sort = frc.utilities.getUrlParameter("sort");
		var regions = frc.utilities.getUrlParameter("regions");
		var geo = null;
		var temp = frc.utilities.getUrlParameter("coords").split(",");
		if(temp.length===2){
			if(!isNaN(window.parseFloat(temp[0])) && !isNaN(window.parseFloat(temp[1]))){
				geo = [ window.parseFloat(temp[0]), window.parseFloat(temp[1]) ];
			}
		}

		var parameters = {};
		if(brandIDs){
			parameters.brandIDs = brandIDs.split(";;");
		}
		if(locationIDs){
			parameters.locationIDs = locationIDs.split(";;");
		}
		if(categories){
			parameters.categories = categories.split(";;");
		}
		if(regions){
			parameters.regions = regions.split(";;");
		}
		if(!isNaN(resultsPerPage)){
			parameters.resultsPerPage = resultsPerPage;
			jQuery("select[name=\"results-per-page\"]").val(resultsPerPage);
		}
		if(!isNaN(maxDistanceMiles)){
			parameters.maxDistanceMiles = Math.min(maxDistanceMiles, self.config.maxDistanceMiles);
		}
		if(sort){
			parameters.sort = sort;
			jQuery("select[name=\"sorting\"]").val(sort);
		}

		// Filters
		var restrictedResults = !!locationIDs; // Determines whether we're filtering on something that can't be reverse via the UI
		var temp = { "restrictedResults": restrictedResults };

		// If restricting by a location IDs, assemble a descriptive string
		if(parameters.locationIDs && parameters.locationIDs.length){
			var locationNames = [];
			parameters.locationIDs.forEach(function(locationId){
				if(locationNamesMap[locationId]){
					locationNames.push(locationNamesMap[locationId]);
				}
			});
			var locationNamesString = "";
			if(locationNames.length){
				if(locationNames.length===1) {
					locationNamesString = locationNames[0];
				} else if(locationNames.length===2) {
					locationNamesString = locationNames.join(" & ");
				} else {
					locationNamesString = locationNames.slice(0, -1).join(", ") + " & " + locationNames.slice(-1);
				}
			}
			temp.locationNamesString = locationNamesString;
		}
		frc.utilities.handlebars.populate("careers-search-filter", temp, ".intro", false);

 		// UI
 		// $('.careers-search-results-header form select').selectric();
 		$('.careers-search-results-header form select').Selecta({ nativeOnMobile: true });
 		$(".careers-module").addClass("loading");

 		$("select[name=\"sorting\"]").on("change", function(){
 			self.data.careersModule.parameters.sort = $(this).val();
 			self.data.careersModule.renderResults();
 		});
 		$("select[name=\"results-per-page\"]").on("change", function(){
 			self.data.careersModule.parameters.resultsPerPage = window.parseFloat($(this).val());
 			self.data.careersModule.renderResults();
 		});

 		$(".filter.controls").each(function(i, filterControl){
 			var filterName = $(filterControl).attr("data-filter");
 			$(filterControl).find(".button").on("click", function(e){
	 			e.preventDefault();
	 			self.resetFiltersUI();
	 			var isActive = !$(this).hasClass("active");
	 			$(".filter.controls .button").removeClass("active");
	 			var filterPanel = $(".filter-panel[data-filter=\"" + filterName + "\"]");

	 			if(isActive){
	 				$(this).addClass("active");
	 				filterPanel.addClass("active");
	 				if (($(window).height() - $('#careers-filter-panels').offset().top) < 100) {
	 					frc.utilities.anchorScroll('#careers-filter-panels', 16);
	 				}
	 			}
 			});
 		});

 		$(".filter.controls.reset-filters a").on("click", function(e){
 			e.preventDefault();
 			self.resetFilters();
 		});

		// Instantiate Careers module
		var module = self.data.careersModule = new frc.modules.careers(".careers-module", parameters);

		$(module).on("resultsrendered", function(jqE, e){
			// Locations filter indicator
			var msg;
			if(module.parameters.coords&&module.parameters.coords.length){
				msg = "your location";
			} else {
				var numSelected = (module.parameters.regions||[]).length;
				msg = numSelected ? numSelected + (numSelected===1? " location" : " locations") : "all locations";
				if(numSelected==$("[data-filter-parameter=\"regions\"] .sub-item").length){
					msg = "all locations";
				}
			}
			jQuery(".filter.controls[data-filter=\"location\"] .indicator").text(msg);

			// Categories filter indicator
			numSelected = (module.parameters.categories||[]).length;
			msg = numSelected ? numSelected + (numSelected===1? " job" : " jobs") : "all jobs";
			if(numSelected==$("[data-filter-parameter=\"categories\"] .sub-item").length){
				msg = "all jobs";
			}

			jQuery(".filter.controls[data-filter=\"categories\"] .indicator").text(msg);

			// Results count
			var $elt = jQuery(".filter-status-message");
			$elt.html("");
			if(e.success){
				$(".careers-module").removeClass("loading");

				if(e.numResults){
					$elt.html("Showing <em>" + e.numResults + "</em> " + (e.numResults===1 ? "job" : "jobs"));
				}
			}
		}).on("dataready", function(){

			// Calculate category result counts
			self.data.categoryCounts = {};
			module.data.listings.forEach(function(listing){
				if(listing.job.categories){
					listing.job.categories.forEach(function(category){
						if(!self.data.categoryCounts[category]){
							self.data.categoryCounts[category] = 0;
						}
						self.data.categoryCounts[category]++;
					});
				}
			});

			self.renderFilters();
		});

		if(geo||query){
			self.data.biasing.type = "geographic";

			if(geo){
				// Coordinates provided via geolocation
				self.data.biasing.method = "geo";
				self.data.biasing.value.coords = geo;
				self.data.careersModule.parameters.coords = geo;
			} else if(query){
				// Query provided
				self.data.biasing.method = "query";
				self.data.biasing.value.raw = query;

				frc.api.core.geocode(self.data.biasing.value.raw, function(result){
					self.data.geocodePerformed = true;
					if(result.data){
						self.data.biasing.value.geocoded = result.data;
						if(result.data.latitude && result.data.longitude){
							self.data.biasing.value.coords = [result.data.latitude, result.data.longitude];
							self.data.careersModule.parameters.coords = self.data.biasing.value.coords;
							$(self).trigger("geocodecomplete", self.data.biasing.value.coords);
							$(self).trigger("parametersset");
						}
					} else {
						// Geocoding failed
						$(self).trigger("geocodefailed");
					}
				});

				return;

			}
		}
		$(self).trigger("parametersset");
 	},
 	"submitLocationQuery": function(){

			var self = frc.pages.careersSearch;

	 		var module = self.data.careersModule;

	 		module.parameters.coords = null;

			var $findLocationZip = $(".find-location-zip");
			var $queryField = $findLocationZip.find("input.fl_zip");
			var query = $.trim($queryField.val());

			// These properties need to match expected deeplinking URL params
			var params = {
				"results": module.parameters.resultsPerPage,
				"sort": module.parameters.sort
			};

			// Location
			if($findLocationZip.hasClass("your-location")){
				params.coords = frc.data.user.geolocation.coordinates.join(",");
			} else {
				if(query){
					params.query = query;
				} else {
					return; // Bail out if no search query provided
				}
			}

			// Distance
			var $maxDistanceDropdown = $("select[name=\"max-distance-miles\"]");
			params.distance = module.parameters.maxDistanceMiles = window.parseFloat($maxDistanceDropdown.val()||$maxDistanceDropdown.find("option").eq(0).attr("value"));

	 		// Categories
	 		if(self.data.careersModule.parameters.categories){
	 			params.categories = self.data.careersModule.parameters.categories.join(";;");
	 		}

	 		// Brands (applies to main FRC site only)
	 		if(!frcContext.brand){
		 		if(self.data.careersModule.parameters.brandIDs){
		 			params.brandIDs = self.data.careersModule.parameters.brandIDs.join(";;");
		 		}
	 		}

			// For analytics
			//$(self).trigger("filtersapplied");

			// Add a delay to let analytics fire
			window.setTimeout(function(){
				window.location.href = "./?" + $.param(params);
			}, 1000);
			self.closeFilters();
 	},
 	"renderFilters": function(){
 		var self = frc.pages.careersSearch;
 		var listings = self.data.careersModule.data.listings;

 		// Locations filter
		var states = {};
		if(listings && listings.length){
			listings.forEach(function(listing){
				if(listing.location.city){
					var state = listing.location.stateUnabbreviated;
					if(!states[state]){
						states[state] = {
							"name": state,
							"abbrev": listing.location.state,
							"numJobs": 0,
							"cities": {}
						};
					}
					var city = jQuery.trim(listing.location.city);
					if(!states[state].cities[city]){
						// Choose default `City, State` display, or a preset location nickname
						let nickname = '';
						if (state == "District Of Columbia" && city == "Washington") {
							nickname = "Washington D.C."
						}
						// Pending client feedback
						// else if (state == "Virginia" && city == "McLean") {
						// 	nickname = "McLean – Tysons Corner"
						// }

						states[state].cities[city] = {
							"name": city,
							"key": window.btoa(state + city),
							"numJobs": 0,
							"nickname": nickname,
						};
					}
					states[state].numJobs++;
					states[state].cities[city].numJobs++;
				}
			});
		}

		// Sort by state, then city
		states = frc.utilities.removeArrayKeys(states).sort(function(a, b){
			return b.name < a.name;
		});
		states.forEach(function(state){
			state.cities = frc.utilities.removeArrayKeys(state.cities).sort(function(a, b){
				return b.name < a.name;
			});
		});
		frc.utilities.handlebars.populate("careers-filter-locations", { "states": states, "numResults": listings.length }, ".filter-panel[data-filter=\"location\"] .wrapper", false);
		var geoSearchCombo = new frc.modules.geoSearchCombo(jQuery("form[data-module-id=\"geo-search-combo\"]"));
		$(geoSearchCombo).on("geolocationcomplete", function(jqE, result){
			if(result.success&&result.coords){
				self.setGeoSearchComboGeolocatedState(true);
			}
		});
		geoSearchCombo.data.$queryField.on("keypress", function(e){
			if(e.keyCode===13){
				// Enter pressed
				self.submitLocationQuery();
			}
		});

		$(".by-query .button.apply-filter").on("click", function(e){
			e.preventDefault();

	 		var self = frc.pages.careersSearch;
	 		self.submitLocationQuery();
		});

 		$(".fl_zip").attr("data-initial-placeholder", $(".fl_zip").attr("placeholder"));

 		var $findLocationZip = $(".find-location-zip");
 		$findLocationZip.find(".pill").on("click", function(){
 			$findLocationZip.removeClass("your-location").find("input.fl_zip").removeAttr("disabled").focus();
 		});
		$findLocationZip.find("input.fl_zip").on("blur", function(){
			if(!$.trim(this.value) && self.data.biasing.method=="geo"){
				$findLocationZip.addClass("your-location").find("input.fl_zip").attr("disabled", "disabled");
			}
		});

		// Categories filter
		frc.api.core.careers.getCategories(null, function(response){
			if(response.data){
				var categories = [];
				response.data.forEach(function(category){
					var temp = {
						"name": category.name,
						"key": window.btoa(category.name),
						"subcategories": [],
						"numJobs": self.data.categoryCounts[category.name] || 0
					};
					category.subcategories.forEach(function(subcategory){
						temp.subcategories.push({
							"name": subcategory,
							"key": window.btoa(category.name + subcategory),
							"numJobs": self.data.categoryCounts[subcategory] || 0
						});
					});
					categories.push(temp);
				});
			}
			frc.utilities.handlebars.populate("careers-filter-categories", { "categories": categories, "numResults": listings.length }, ".filter-panel[data-filter=\"categories\"] .wrapper", false);
			self.initFilters();
		});

		$('.filter-panel select').Selecta({ nativeOnMobile: true });
 	},
 	"closeFilters": function(){
 		$(".filter-panel, .filter.controls .button").removeClass("active");
 	},
 	"resetFilters": function(){
 		var self = frc.pages.careersSearch;
 		self.data.careersModule.parameters.coords = null;
 		self.data.careersModule.parameters.regions = null;
 		self.data.careersModule.parameters.categories = null;
 		self.data.careersModule.renderResults();
 	},
 	"setGeoSearchComboGeolocatedState": function(enabled){
 		if(enabled){
 			jQuery(".find-location-zip").addClass("your-location");
 			jQuery(".fl_zip").val("").attr("placeholder", "").attr("disabled", "disabled");
 		} else {
 			jQuery(".find-location-zip").removeClass("your-location");
 			jQuery(".fl_zip").val("").attr("placeholder", jQuery(".fl_zip").attr("data-initial-placeholder")).removeAttr("disabled");
 		}
 	},
 	"resetFiltersUI": function(){
 		var self = frc.pages.careersSearch;
 		self.closeFilters();

 		self.setGeoSearchComboGeolocatedState(false);

 		if(self.data.biasing.type=="geographic"){
	 		if(self.data.biasing.method=="query"){
	 			jQuery(".fl_zip").val(self.data.biasing.value.raw);
	 		} else if(self.data.biasing.method=="geo"){
	 			self.setGeoSearchComboGeolocatedState(true);
	 		}
 		}

 		$('.filter-panel select').Selecta("refresh");

 		// Distance dropdown
		// jQuery("select[name=\"max-distance-miles\"]").val(self.data.careersModule.parameters.maxDistanceMiles).Selecta("refresh");

 		// Uncheck all filter options in filter panels to start with
		jQuery(".filter-panel .definition input[type=\"checkbox\"]").prop("checked", false);

		// Check filter options to match parameters
		jQuery(".filter-panel [data-filter-parameter]").each(function(i, elt){
			var parameterName = $(elt).attr("data-filter-parameter");
			if(self.data.careersModule.parameters[parameterName]){
				self.data.careersModule.parameters[parameterName].forEach(function(selectedValue){
					$(elt).find(".sub-item[data-value=\"" + window.unescape(selectedValue) + "\"] input[type=\"checkbox\"]").prop("checked", true);
				});
			}
		});

		// If all sub items are selected under a definition, select the main item as well
		$(".filter-panel .definitions .definition").each(function(i, elt){
			self.syncFilterOptions($(elt));
		});

 	},
 	"syncFilterOptions": function($definition){
 		var $subItems = $definition.find(".sub-item input[type=\"checkbox\"]");
		var numUnselectedOptions = $subItems.filter(":not(:checked)").length;
		var state;
		if(!numUnselectedOptions){
			state = "all";
		} else if(numUnselectedOptions<$subItems.length) {
			state = "partial";
		} else {
			state = "none";
		}

		var $mainItem = $definition.find(".main-item:not(.select-all)");
		$mainItem.attr("data-selection-state", state);
		$mainItem.find("input[type=\"checkbox\"]").prop("checked", state == "all");

 	},
 	"initFilters": function(){
 		var self = frc.pages.careersSearch;

		// Wire up "Apply Filters" buttons
		$(".by-region .button.apply-filter, .by-category .button.apply-filter").on("click", function(e){
			self.closeFilters();
			e.preventDefault();
			var $parameterElement = $(this).parents(".by-region, .by-category").find("[data-filter-parameter]");
			var parameterName = $parameterElement.attr("data-filter-parameter");
			var $selections = $parameterElement.find("input:checked");
			var selections = [];
			$selections.each(function(i, selection){
				var val = $(selection).parent("[data-value]").attr("data-value");
				if(val){
					selections.push(val);
				}
			});
			self.data.careersModule.parameters[parameterName] = selections.length ? selections : null;

			self.data.careersModule.renderResults();

			// For analytics
			$(self).trigger("filtersapplied", parameterName);
		});

		// Capture clicks on filtering items via .filter-panels do we don't have to attach an onclick to each item individually or wait until they're rendered via Handlebars.
		$(".filter-panels").on("click", function(e){
			if(e.target.nodeName=="INPUT"){
				e.stopPropagation();
				var $definition = $(e.target).parents(".definition");
				if($definition.length){
					$selectAll = $(e.target).parents(".main-item.select-all");
					if($selectAll.length){
						// "Select All" item clicked
						var $parameterElement = $selectAll.parents("[data-filter-parameter]");
						var shouldSelectAll = e.target.checked;
						$parameterElement.find("input[type=\"checkbox\"]").prop("checked", shouldSelectAll);
						$parameterElement.find(".main-item").attr("data-selection-state", shouldSelectAll?"all":"none");
						self.syncFilterOptions($definition);
					} else {
						$mainItem = $(e.target).parents(".main-item:not(.select-all)");
						if($mainItem.length){
							// Main item clicked
							var currentState = $mainItem.attr("data-selection-state");
							var shouldSelectAll = currentState != "all" && currentState != "partial";
							$definition.find(".sub-item input[type=\"checkbox\"]").prop("checked", shouldSelectAll);
							self.syncFilterOptions($definition);
						} else {
							// Sub item clicked
							if($(e.target).parents(".sub-item").length){
								self.syncFilterOptions($definition);
							}
						}
					}
				}
			} else if(e.target.nodeName=="A") {
				if($(e.target).hasClass("filter-close")){
					e.preventDefault();
			 		self.closeFilters();
				}
			}
		});

 	}
 };
